import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function TeacherSignup() {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    type: "",
    message: "",
  });

  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  // Auto-resize textarea
  const textareaRef = useRef(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [formData.message]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setErrorMessages([]);
    setSuccessMessage("");

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "signup-requests/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        if (Array.isArray(data.message)) {
          setErrorMessages(data.message);
        } else {
          setErrorMessages([data.message || t("signup_error")]);
        }
        return;
      }

      setSuccessMessage(data.message);
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setErrorMessages([t("signup_generic_error")]);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center h-100 w-100">
      <Container>
        <Row className="justify-content-center w-100">
          <Col md={5} className="m-4 p-4">
            <h2 className="text-center mb-4">{t("contact_us")}</h2>
            <p>{t("contact_us_description")}</p>
            <Form onSubmit={handleSignup}>
              <Form.Group className="mb-3" controlId="first_name">
                <Form.Label>{t("first_name")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("enter_first_name")}
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="last_name">
                <Form.Label>{t("last_name")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("enter_last_name")}
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>{t("email")}</Form.Label>
                <Form.Control
                  type="email"
                  placeholder={t("enter_email")}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>{t("password")}</Form.Label>
                <Form.Control
                  type="password"
                  placeholder={t("enter_password")}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="type">
                <Form.Label>{t("i_am_a")}</Form.Label>
                <Form.Select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                >
                  <option>{t("choose_option")}</option>
                  <option value="universitaire">
                    {t("university_teacher")}
                  </option>
                  <option value="collégial">{t("college_teacher")}</option>
                  <option value="professionnel">{t("professional")}</option>
                  <option value="autre">{t("other")}</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3" controlId="message">
                <Form.Label>{t("message")}</Form.Label>
                <Form.Control
                  ref={textareaRef}
                  as="textarea"
                  rows={1}
                  placeholder={t("enter_message")}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={500}
                  style={{ overflow: "hidden", resize: "none" }}
                />
              </Form.Group>
              <Button type="submit" variant="primary" className="w-100">
                {t("send")}
              </Button>
              <div className="mt-3 text-center">
                {t("request_processing_message")}
              </div>
              {errorMessages.length > 0 && (
                <Alert variant="danger" className="mt-3">
                  {errorMessages[0]}
                </Alert>
              )}
              {successMessage && (
                <Alert variant="success" className="mt-3">
                  {successMessage}
                </Alert>
              )}
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TeacherSignup;
